import { ImagePlus } from "lucide-react";

/**
 * Image slot for a product photo. When the owner has supplied a real photo
 * (`src`), it is shown directly; otherwise a clearly-labeled placeholder is
 * rendered. Placeholders are never silently replaced with stock imagery.
 */
const ProductPlaceholder = ({ label, ratio = "aspect-[4/3]", testId, src, alt }) => {
  if (src) {
    return (
      <div data-testid={testId} className={`${ratio} w-full rounded-2xl overflow-hidden bg-sage-light`}>
        <img src={src} alt={alt || label} className="w-full h-full object-cover" loading="lazy" />
      </div>
    );
  }
  return (
    <div
      data-testid={testId}
      className={`${ratio} w-full rounded-2xl border-2 border-dashed border-sage/50 bg-sage-light flex flex-col items-center justify-center gap-3 p-6 text-center`}
    >
      <ImagePlus className="h-10 w-10 text-sage/70" aria-hidden="true" />
      <p className="font-heading font-bold text-sage text-lg leading-snug">{label}</p>
      <p className="text-sm text-sage/80 uppercase tracking-widest font-semibold">Product photo placeholder</p>
    </div>
  );
};

export default ProductPlaceholder;
